import script from "./GridModeDataNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./GridModeDataNotification.vue?vue&type=script&setup=true&lang=js"

import "./GridModeDataNotification.vue?vue&type=style&index=0&id=25e8f20e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e8f20e"]])

export default __exports__